import { muiDisabled, muiFocused, muiFocusVisible } from '../themes/base.theme';

const muiCheckboxOverride = {
  defaultProps: {
    disableFocusRipple: true,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      padding: 0,
      color: theme?.components?.checkbox?.base?.rippleColor,
      marginRight: theme?.components?.checkbox?.base?.labelSpacing || '0.5rem',

      [`&:hover:not(:disabled)`]: {
        [`& .MuiSvgIcon-root, & > svg`]: {
          [`& rect`]: {
            ...(theme?.components?.checkbox?.states?.hover || {}),
          },
        },
      },

      [`& .MuiSvgIcon-root, & > svg`]: {
        width: theme?.components?.checkbox?.base?.width,
        height: theme?.components?.checkbox?.base?.height,
        transition: 'box-shadow 0.2s ease-in-out',

        [`& rect`]: {
          transition: 'fill 0.2s ease-in-out',
          stroke: theme?.components?.checkbox?.base?.borderColor,
        },
      },

      [`&.${muiFocused} svg, &.${muiFocusVisible} svg`]: {
        borderRadius: theme?.components?.checkbox?.base?.border?.radius,
        boxShadow: theme?.shadows[4],
        ...(theme?.components?.checkbox?.states?.focusVisible || {}),
      },

      [`&.Mui-checked`]: {
        color: theme?.components?.checkbox?.states?.checked?.rippleColor,

        [`> svg`]: {
          [`& rect`]: {
            stroke: theme?.components?.checkbox?.states?.checked?.border?.color,
          },
        },
      },

      [`&.${muiDisabled}`]: {
        [`& .MuiSvgIcon-root rect, & > svg rect`]: {
          stroke: theme?.components?.checkbox?.states?.disabled?.borderColor,
        },
      },
    }),
  },
  variants: [],
};

export default muiCheckboxOverride;
